const SESSION_ID_KEY = 'sessionId';

export const getSessionId = () => localStorage.getItem(SESSION_ID_KEY);

export const setSessionId = (sessionId) => {
  localStorage.setItem(SESSION_ID_KEY, sessionId);
};

export const clearSessionId = () => {
  localStorage.removeItem(SESSION_ID_KEY);
};
